/* eslint-disable react/jsx-no-useless-fragment */

import { InteractionStatus } from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react';
import { Navigate, useLocation } from 'react-router-dom';

const disableAuth = process.env.NX_DISABLE_AUTH || false;

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { inProgress } = useMsal();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();

  if (disableAuth) {
    return <>{children}</>;
  }

  if (inProgress === InteractionStatus.None && !isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <Navigate to="/sign-in" state={{ from: location }} replace />
      </UnauthenticatedTemplate>
    );
  }

  return <AuthenticatedTemplate>{children}</AuthenticatedTemplate>;
}
